import React from "react";
import PropTypes from "prop-types";
import { dummyBrand } from "../../consts/brands";

import { MyDraggable as Draggable } from "../../components/Core";
import HoverBar from "../../components/HoverBar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";

import state from "../../state";
import { generateStyle, l, setOverLay } from "../../functions";
import Icon from "../../components/Icons";
import isEqual from "lodash/isEqual";

class BrandImage extends React.Component {
  constructor(props) {
    super(props);
  }
  shouldComponentUpdate(nextProp, nextState) {
    if (!isEqual(this.props?.payload, nextProp?.payload)) {
      return true;
    }

    return false;
  }

  _initCarousel = () => {
    let { payload } = this.props;

    if (payload === null) payload = this.props.options.payload;

    const {
      sizeMode,
      displayMode = "ratio",
      imageWidth,
      imageHeight,
    } = payload.datas || {};

    const cssSettings = generateStyle(payload, "container");
    const cssAlignment = generateStyle(payload, "alignment");

    let customCSS = {};

    let backgroundSize = "cover";

    if (displayMode === "stretch") backgroundSize = "100% 100%";
    else if (displayMode === "ratio") backgroundSize = "contain";
    else backgroundSize = "cover";

    if (sizeMode === "custom") {
      customCSS = {
        height: imageWidth ? parseInt(imageWidth) : 250,
        width: imageWidth ? parseInt(imageWidth) : 250,
        backgroundSize: backgroundSize,
        backgroundImage: "url(" + dummyBrand.image + ")",
      };
    }

    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        {setOverLay(payload)}
        <Row>
          <Col xs={12} className="fullcol category-image">
            <div style={cssAlignment}>
              {(sizeMode === "custom" && (
                <div className="customImage" style={customCSS}></div>
              )) || <img src={dummyBrand.image} alt={dummyBrand.name} />}
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      const elements = state.getStorableState();

      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initCarousel()}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initCarousel()}
      </Draggable>
    );
  }
}

BrandImage.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default BrandImage;
